export default "__VITE_ASSET__CK_FOoIS__"